






















































import Vue from 'vue';
import { BankAccount } from '@/components/account-settings-components/personal-settings-components/banking-components/banking-child-components';
import { MemberBankAccountResponseModel } from '@/@types/member';

export default Vue.extend({
  name: 'BankAccounts',
  props: {
    bankAccounts: {
      type: Array as () => any[],
      required: true,
    },
  },
  computed: {
    primaryBankAccount(): MemberBankAccountResponseModel {
      return this.$store.getters.primaryBankAccount;
    },
    displayBankAccountExpander(): boolean {
      return this.bankAccounts.length > 1;
    },
  },
  components: {
    BankAccount,
  },
});
